<script>
import { BNav } from 'bootstrap-vue'

export default {
  extends: BNav,
}
</script>
